import { FC } from "react";
import { useTranslation } from "react-i18next";

import { CollapsibleMapLegend, MapLegendSwatchStyled } from "@ryde/controls";

import { LEGEND_ROWS } from "../investigation.constants";

/**
 * Map key for the investigation trail layers (teal planned, blue actual, grey gap, red detour), rendered
 * through the shared collapsible map legend so the collapse behavior stays in one place.
 */
export const InvestigationMapLegend: FC = () => {
  const { t } = useTranslation();

  return (
    <CollapsibleMapLegend title={t("rideMap.LEGEND_TITLE")}>
      {LEGEND_ROWS.map(row => (
        <span key={row.labelKey} className="map-legend__row">
          <MapLegendSwatchStyled $color={row.color} $lineStyle={row.dash} />
          {t(row.labelKey)}
        </span>
      ))}
    </CollapsibleMapLegend>
  );
};
